import React, { Fragment, useEffect, useState } from 'react';
import AdminBuilderService from '../../../API/Services/AdminService/AdminBuilderService';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";
import { Button } from 'react-bootstrap';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { Tooltip } from 'react-tooltip';
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const FilterPermits = () => {
    const navigate = useNavigate();
    const [builderListDropDown, setBuilderListDropDown] = useState([]);
    const [selectedBuilderNameByFilter, setSelectedBuilderNameByFilter] = useState([]);
    const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
    const [gasProviderDropDown, setGasProviderDropDown] = useState([]);
    const [selectedBuilderIDByFilter, setSelectedBuilderIDByFilter] = useState([]);
    const [selectedSubdivisionNameByFilter, setSelectedSubdivisionNameByFilter] = useState([]);
    const [productTypeStatusByFilter, setProductTypeStatusByFilter] = useState([]);
    const [selectedAreaByFilter, setSelectedAreaByFilter] = useState([]);
    const [selectedMasterPlanByFilter, setSelectedMasterPlanByFilter] = useState([]);
    const [selectedAgeByFilter, setSelectedAgeByFilter] = useState([]);
    const [selectedSingleByFilter, setSelectedSingleByFilter] = useState([]);
    const [selectedJurisdicitionByFilter, setSelectedJurisdictionByFilter] = useState([]);
    const [seletctedGasProviderByFilter, setSelectedGasProviderByFilter] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [message, setMessage] = useState(false);
    const handlePopupClose = () => setShowPopup(false);
    const [filterQuery, setFilterQuery] = useState({
        from: localStorage.getItem("from_Permit") ? JSON.parse(localStorage.getItem("from_Permit")) : "",
        to: localStorage.getItem("to_Permit") ? JSON.parse(localStorage.getItem("to_Permit")) : "",
        builder_name: localStorage.getItem("builder_name_Permit") ? JSON.parse(localStorage.getItem("builder_name_Permit")) : "",
        subdivision_name: localStorage.getItem("subdivision_name_Permit") ? JSON.parse(localStorage.getItem("subdivision_name_Permit")) : "",
        address2: localStorage.getItem("address2_Permit") ? JSON.parse(localStorage.getItem("address2_Permit")) : "",
        address1: localStorage.getItem("address1_Permit") ? JSON.parse(localStorage.getItem("address1_Permit")) : "",
        parcel: localStorage.getItem("parcel_Permit") ? JSON.parse(localStorage.getItem("parcel_Permit")) : "",
        sqft: localStorage.getItem("sqft_Permit") ? JSON.parse(localStorage.getItem("sqft_Permit")) : "",
        lotnumber: localStorage.getItem("lotnumber_Permit") ? JSON.parse(localStorage.getItem("lotnumber_Permit")) : "",
        permitnumber: localStorage.getItem("permitnumber_Permit") ? JSON.parse(localStorage.getItem("permitnumber_Permit")) : "",
        plan: localStorage.getItem("plan_Permit") ? JSON.parse(localStorage.getItem("plan_Permit")) : "",
        product_type: localStorage.getItem("product_type_Permit") ? JSON.parse(localStorage.getItem("product_type_Permit")) : "",
        area: localStorage.getItem("area_Permit") ? JSON.parse(localStorage.getItem("area_Permit")) : "",
        masterplan_id: localStorage.getItem("masterplan_id_Permit") ? JSON.parse(localStorage.getItem("masterplan_id_Permit")) : "",
        zipcode: localStorage.getItem("zipcode_Permit") ? JSON.parse(localStorage.getItem("zipcode_Permit")) : "",
        lotwidth: localStorage.getItem("lotwidth_Permit") ? JSON.parse(localStorage.getItem("lotwidth_Permit")) : "",
        lotsize: localStorage.getItem("lotsize_Permit") ? JSON.parse(localStorage.getItem("lotsize_Permit")) : "",
        age: localStorage.getItem("age_Permit") ? JSON.parse(localStorage.getItem("age_Permit")) : "",
        single: localStorage.getItem("single_Permit") ? JSON.parse(localStorage.getItem("single_Permit")) : "",
        juridiction: localStorage.getItem("juridiction_Permit") ? JSON.parse(localStorage.getItem("juridiction_Permit")) : "",
        gasprovider: localStorage.getItem("gasprovider_Permit") ? JSON.parse(localStorage.getItem("gasprovider_Permit")) : "",
    });

    useEffect(() => {
        if(localStorage.getItem("selectedBuilderNameByFilter_Permit")) {
            const selectedBuilderName = JSON.parse(localStorage.getItem("selectedBuilderNameByFilter_Permit"));
            handleSelectBuilderNameChange(selectedBuilderName);
        }
        if(localStorage.getItem("selectedSubdivisionNameByFilter_Permit")) {
          const selectedSubdivisionName = JSON.parse(localStorage.getItem("selectedSubdivisionNameByFilter_Permit"));
          handleSelectSubdivisionNameChange(selectedSubdivisionName);
        }
        if(localStorage.getItem("productTypeStatusByFilter_Permit")) {
          const productTypeStatus = JSON.parse(localStorage.getItem("productTypeStatusByFilter_Permit"));
          handleSelectProductTypeChange(productTypeStatus);
        }
        if(localStorage.getItem("selectedAreaByFilter_Permit")) {
            const selectedArea = JSON.parse(localStorage.getItem("selectedAreaByFilter_Permit"));
            handleSelectAreaChange(selectedArea);
        }
        if(localStorage.getItem("selectedMasterPlanByFilter_Permit")) {
          const selectedMasterPlan = JSON.parse(localStorage.getItem("selectedMasterPlanByFilter_Permit"));
          handleSelectMasterPlanChange(selectedMasterPlan);
        }
        if(localStorage.getItem("selectedAgeByFilter_Permit")) {
            const selectedAge = JSON.parse(localStorage.getItem("selectedAgeByFilter_Permit"));
            handleSelectAgeChange(selectedAge);
        }
        if(localStorage.getItem("selectedSingleByFilter_Permit")) {
          const selectedSingle = JSON.parse(localStorage.getItem("selectedSingleByFilter_Permit"));
          handleSelectSingleChange(selectedSingle);
        }
        if (localStorage.getItem("selectedJurisdicitionByFilter_Permit")) {
            const selectedJurisdicition = JSON.parse(localStorage.getItem("selectedJurisdicitionByFilter_Permit"));
            handleSelectJurisdictionChange(selectedJurisdicition);
        }
        if (localStorage.getItem("seletctedGasProviderByFilter_Permit")) {
            const seletctedGasProvider = JSON.parse(localStorage.getItem("seletctedGasProviderByFilter_Permit"));
            handleGasProviderChange(seletctedGasProvider);
        }
    }, []);

    useEffect(() => {
        if (localStorage.getItem("usertoken")) {
            GetBuilderDropDownList();
            GetMasterPlanDropDownList();
            GetGasProviderDropDownList();
        } else {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (selectedSubdivisionNameByFilter?.length === 0) {
            setFilterQuery(prevState => ({
                ...prevState,
                subdivision_name: ""
            }));
        }
    }, [selectedSubdivisionNameByFilter]);

    useEffect(() => {
        setSearchQuery(filterString());
    }, [filterQuery]);

    const filterString = () => {
        const queryString = Object.keys(filterQuery)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(filterQuery[key])}`
            )
            .join("&");

        return queryString ? `&${queryString}` : "";
    };

    const GetBuilderDropDownList = async () => {
        try {
            const response = await AdminBuilderService.builderDropDown();
            const responseData = await response.json();
            const formattedData = responseData.map((builder) => ({
                label: builder.name,
                value: builder.id,
            }));
            setBuilderListDropDown(formattedData);
        } catch (error) {
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
            }
        }
    };

    const GetMasterPlanDropDownList = async () => {
        try {
            const response = await AdminBuilderService.masterPlanDropDown();
            const responseData = await response.json();
            const formattedData = responseData.map((masterPlan) => ({
                label: masterPlan.label,
                value: masterPlan.value,
            }));
            setMasterPlanDropDownList(formattedData);
        } catch (error) {
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
            }
        }
    };

    const GetGasProviderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.gasProviderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((gas_provider) => ({
        label: gas_provider.label,
        value: gas_provider.value,
      }));
      setGasProviderDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

    const HandlePopupDetailClick = (e) => {
        setShowPopup(true);
    };

    useEffect(() => {
        if (filterQuery.from == "" || filterQuery.to == "") {
            if(localStorage.getItem("setPermitFilter") == "true") {
                setShowPopup(true);
                setMessage("Please select date.");
                localStorage.removeItem("setPermitFilter");
                return;
            }
        } else {
            if(localStorage.getItem("setPermitFilter") == "true") {
                if((searchQuery == "") || (searchQuery == "&from=&to=&builder_name=&subdivision_name=&address2=&address1=&parcel=&sqft=&lotnumber=&permitnumber=&plan=&product_type=&area=&masterplan_id=&zipcode=&lotwidth=&lotsize=&age=&single=&gasprovider=")){
                    return;
                } else {
                    let startDate = moment(filterQuery.from);
                    let endDate = moment(filterQuery.to);
                    let days = endDate.diff(startDate, 'days', true);
                    let totaldays = Math.ceil(days) + 1;
                    // if (totaldays < 367) {
                        navigate("/permitlist");
                        localStorage.setItem("selectedBuilderNameByFilter_Permit", JSON.stringify(selectedBuilderNameByFilter));
                        localStorage.setItem("selectedSubdivisionNameByFilter_Permit", JSON.stringify(selectedSubdivisionNameByFilter));
                        localStorage.setItem("productTypeStatusByFilter_Permit", JSON.stringify(productTypeStatusByFilter));
                        localStorage.setItem("selectedAreaByFilter_Permit", JSON.stringify(selectedAreaByFilter));
                        localStorage.setItem("selectedMasterPlanByFilter_Permit", JSON.stringify(selectedMasterPlanByFilter));
                        localStorage.setItem("selectedAgeByFilter_Permit", JSON.stringify(selectedAgeByFilter));
                        localStorage.setItem("selectedSingleByFilter_Permit", JSON.stringify(selectedSingleByFilter));
                        localStorage.setItem("selectedJurisdicitionByFilter_Permit", JSON.stringify(selectedJurisdicitionByFilter));
                        localStorage.setItem("seletctedGasProviderByFilter_Permit", JSON.stringify(seletctedGasProviderByFilter));
                        localStorage.setItem("from_Permit", JSON.stringify(filterQuery.from));
                        localStorage.setItem("to_Permit", JSON.stringify(filterQuery.to));
                        localStorage.setItem("builder_name_Permit", JSON.stringify(filterQuery.builder_name));
                        localStorage.setItem("subdivision_name_Permit", JSON.stringify(filterQuery.subdivision_name));
                        localStorage.setItem("address2_Permit", JSON.stringify(filterQuery.address2));
                        localStorage.setItem("address1_Permit", JSON.stringify(filterQuery.address1));
                        localStorage.setItem("parcel_Permit", JSON.stringify(filterQuery.parcel));
                        localStorage.setItem("sqft_Permit", JSON.stringify(filterQuery.sqft));
                        localStorage.setItem("lotnumber_Permit", JSON.stringify(filterQuery.lotnumber));
                        localStorage.setItem("permitnumber_Permit", JSON.stringify(filterQuery.permitnumber));
                        localStorage.setItem("plan_Permit", JSON.stringify(filterQuery.plan));
                        localStorage.setItem("product_type_Permit", JSON.stringify(filterQuery.product_type));
                        localStorage.setItem("area_Permit", JSON.stringify(filterQuery.area));
                        localStorage.setItem("masterplan_id_Permit", JSON.stringify(filterQuery.masterplan_id));
                        localStorage.setItem("zipcode_Permit", JSON.stringify(filterQuery.zipcode));
                        localStorage.setItem("lotwidth_Permit", JSON.stringify(filterQuery.lotwidth));
                        localStorage.setItem("lotsize_Permit", JSON.stringify(filterQuery.lotsize));
                        localStorage.setItem("age_Permit", JSON.stringify(filterQuery.age));
                        localStorage.setItem("single_Permit", JSON.stringify(filterQuery.single));
                        localStorage.setItem("juridiction_Permit", JSON.stringify(filterQuery.juridiction));
                        localStorage.setItem("gasprovider_Permit", JSON.stringify(filterQuery.gasprovider));
                        localStorage.setItem("searchQueryByPermitsFilter", JSON.stringify(searchQuery.replace(/^"",|,""$/g, '')));
                    // } else {
                    //     setShowPopup(true);
                    //     setMessage("Please select date between 366 days.");
                    //     localStorage.removeItem("setPermitFilter");
                    //     return;
                    // }
                }
            }
        }
    }, [searchQuery]);

    const HandleFilterForm = (e) => {
        if (filterQuery.from == "" || filterQuery.to == "") {
            setShowPopup(true);
            if(filterQuery.from == "" && filterQuery.to == "") {
                setMessage("Please select from and to date.");
            } else if (filterQuery.from == "") {
                setMessage("Please select from date.");
            } else if (filterQuery.to == "") {
                setMessage("Please select to date.");
            }
            return;
        } else {
            let startDate = moment(filterQuery.from);
            let endDate = moment(filterQuery.to);
            let days = endDate.diff(startDate, 'days', true);
            let totaldays = Math.ceil(days) + 1;
            // if (totaldays < 367) {
                e.preventDefault();
                navigate("/permitlist");
                localStorage.setItem("selectedBuilderNameByFilter_Permit", JSON.stringify(selectedBuilderNameByFilter));
                localStorage.setItem("selectedSubdivisionNameByFilter_Permit", JSON.stringify(selectedSubdivisionNameByFilter));
                localStorage.setItem("productTypeStatusByFilter_Permit", JSON.stringify(productTypeStatusByFilter));
                localStorage.setItem("selectedAreaByFilter_Permit", JSON.stringify(selectedAreaByFilter));
                localStorage.setItem("selectedMasterPlanByFilter_Permit", JSON.stringify(selectedMasterPlanByFilter));
                localStorage.setItem("selectedAgeByFilter_Permit", JSON.stringify(selectedAgeByFilter));
                localStorage.setItem("selectedSingleByFilter_Permit", JSON.stringify(selectedSingleByFilter));
                localStorage.setItem("selectedJurisdicitionByFilter_Permit", JSON.stringify(selectedJurisdicitionByFilter));
                localStorage.setItem("seletctedGasProviderByFilter_Permit", JSON.stringify(seletctedGasProviderByFilter));
                localStorage.setItem("from_Permit", JSON.stringify(filterQuery.from));
                localStorage.setItem("to_Permit", JSON.stringify(filterQuery.to));
                localStorage.setItem("builder_name_Permit", JSON.stringify(filterQuery.builder_name));
                localStorage.setItem("subdivision_name_Permit", JSON.stringify(filterQuery.subdivision_name));
                localStorage.setItem("address2_Permit", JSON.stringify(filterQuery.address2));
                localStorage.setItem("address1_Permit", JSON.stringify(filterQuery.address1));
                localStorage.setItem("parcel_Permit", JSON.stringify(filterQuery.parcel));
                localStorage.setItem("sqft_Permit", JSON.stringify(filterQuery.sqft));
                localStorage.setItem("lotnumber_Permit", JSON.stringify(filterQuery.lotnumber));
                localStorage.setItem("permitnumber_Permit", JSON.stringify(filterQuery.permitnumber));
                localStorage.setItem("plan_Permit", JSON.stringify(filterQuery.plan));
                localStorage.setItem("product_type_Permit", JSON.stringify(filterQuery.product_type));
                localStorage.setItem("area_Permit", JSON.stringify(filterQuery.area));
                localStorage.setItem("masterplan_id_Permit", JSON.stringify(filterQuery.masterplan_id));
                localStorage.setItem("zipcode_Permit", JSON.stringify(filterQuery.zipcode));
                localStorage.setItem("lotwidth_Permit", JSON.stringify(filterQuery.lotwidth));
                localStorage.setItem("lotsize_Permit", JSON.stringify(filterQuery.lotsize));
                localStorage.setItem("age_Permit", JSON.stringify(filterQuery.age));
                localStorage.setItem("single_Permit", JSON.stringify(filterQuery.single));
                localStorage.setItem("juridiction_Permit", JSON.stringify(filterQuery.juridiction));
                localStorage.setItem("gasprovider_Permit", JSON.stringify(filterQuery.gasprovider));
                localStorage.setItem("searchQueryByPermitsFilter", JSON.stringify(searchQuery.replace(/^"",|,""$/g, '')));
                localStorage.setItem("setPermitFilter", true);
            // } else {
            //     setShowPopup(true);
            //     setMessage("Please select date between 366 days.");
            //     return;
            // }
        }
    };

    const handleFilterDateFrom = (date) => {
        if (date) {
            const formattedDate = date.toLocaleDateString('en-US');

            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                from: formattedDate,
            }));
        } else {
            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                from: '',
            }));
        }
    };

    const handleFilterDateTo = (date) => {
        if (date) {
            const formattedDate = date.toLocaleDateString('en-US');

            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                to: formattedDate,
            }));
        } else {
            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                to: '',
            }));
        }
    };

    const parseDate = (dateString) => {
        const [month, day, year] = dateString.split('/');
        return new Date(year, month - 1, day);
    };

    const handleSelectBuilderNameChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.label).join(', ');
        const selectedValues = selectedItems.map(item => item.value);
        setSelectedBuilderIDByFilter(selectedValues);
        setSelectedBuilderNameByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            builder_name: selectedNames
        }));
    };

    const handleSelectSubdivisionNameChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.label).join(', ');

        setSelectedSubdivisionNameByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            subdivision_name: selectedNames
        }));
    };

    const HandleFilter = (e) => {
        const { name, value } = e.target;
        setFilterQuery((prevFilterQuery) => ({
            ...prevFilterQuery,
            [name]: value,
        }));
    };

    const handleSelectProductTypeChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setProductTypeStatusByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            product_type: selectedNames
        }));
    };

    const handleSelectAreaChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');

        setSelectedAreaByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            area: selectedValues
        }));
    };

    const handleSelectMasterPlanChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');

        setSelectedMasterPlanByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            masterplan_id: selectedValues
        }));
    };

    const handleSelectAgeChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setSelectedAgeByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            age: selectedNames
        }));
    };

    const handleSelectSingleChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setSelectedSingleByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            single: selectedNames
        }));
    };

    const handleSelectJurisdictionChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');
        setSelectedJurisdictionByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            juridiction: selectedValues
        }));
    };

    const jurisdictionOption = [
        { value: "Boulder City", label: "Boulder City" },
        { value: "CLV", label: "CLV" },
        { value: "CC Enterprise", label: "CC Enterprise" },
        { value: "CC Indian Springs", label: "CC Indian Springs" },
        { value: "CC Laughlin", label: "CC Laughlin" },
        { value: "CC Lone Mtn", label: "CC Lone Mtn" },
        { value: "CC Lower Kyle Canyon", label: "CC Lower Kyle Canyon" },
        { value: "CC Moapa Valley", label: "CC Moapa Valley" },
        { value: "CC Mt Charleston", label: "CC Mt Charleston" },
        { value: "CC Mtn Springs", label: "CC Mtn Springs" },
        { value: "CC Paradise", label: "CC Paradise" },
        { value: "CC Searchlight", label: "CC Searchlight" },
        { value: "CC Spring Valley", label: "CC Spring Valley" },
        { value: "CC Summerlin South", label: "CC Summerlin South" },
        { value: "CC Sunrise Manor", label: "CC Sunrise Manor" },
        { value: "CC Whiteney", label: "CC Whiteney" },
        { value: "CC Winchester", label: "CC Winchester" },
        { value: "CC Unincorporated", label: "CC Unincorporated" },
        { value: "Henderson", label: "Henderson" },
        { value: "Mesquite", label: "Mesquite" },
        { value: "NLV", label: "NLV" },
        { value: "NYE", label: "NYE" },
    ];

    const productTypeOptions = [
        { value: "DET", label: "DET" },
        { value: "ATT", label: "ATT" },
        { value: "HR", label: "HR" },
        { value: "AC", label: "AC" }
    ];

    const areaOption = [
        { value: "BC", label: "BC" },
        { value: "E", label: "E" },
        { value: "H", label: "H" },
        { value: "IS", label: "IS" },
        { value: "L", label: "L" },
        { value: "MSQ", label: "MSQ" },
        { value: "MV", label: "MV" },
        { value: "NLV", label: "NLV" },
        { value: "NW", label: "NW" },
        { value: "P", label: "P" },
        { value: "SO", label: "SO" },
        { value: "SW", label: "SW" }
    ];

    const ageOptions = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" }
    ];

    const singleOptions = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" }
    ];

    const handleGasProviderChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');
        setSelectedGasProviderByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            gasprovider: selectedValues
        }));
    };

    // const gasProviderOption = [
    //     { value: "SOUTHWEST GAS", label: "SOUTHWEST GAS" },
    // ];

    const HandleCancelFilter = () => {
        setFilterQuery({
            from: "",
            to: "",
            builder_name: "",
            subdivision_name: "",
            address2: "",
            address1: "",
            parcel: "",
            sqft: "",
            lotnumber: "",
            permitnumber: "",
            plan: "",
            product_type: "",
            area: "",
            masterplan_id: "",
            zipcode: "",
            lotwidth: "",
            lotsize: "",
            age: "",
            single: "",
            juridiction: "",
            gasprovider: "",
        });
        setSelectedBuilderNameByFilter([]);
        setSelectedSubdivisionNameByFilter([]);
        setProductTypeStatusByFilter([]);
        setSelectedAreaByFilter([]);
        setSelectedMasterPlanByFilter([]);
        setSelectedAgeByFilter([]);
        setSelectedSingleByFilter([]);
        setSelectedJurisdictionByFilter([]);
        setSelectedGasProviderByFilter([]);
        setSelectedBuilderIDByFilter([]);
    };

    return (
        <Fragment>
            <div className="container mt-5">
                <h2>Filter Permits</h2>
                <form onSubmit={HandleFilterForm}>
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <label className="form-label">From:{" "}
                                <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                name="from"
                                className="form-control"
                                selected={filterQuery.from ? parseDate(filterQuery.from) : null}
                                onChange={handleFilterDateFrom}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">To:{" "}
                                <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                name="to"
                                className="form-control"
                                selected={filterQuery.to ? parseDate(filterQuery.to) : null}
                                onChange={handleFilterDateTo}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">BUILDER NAME:{" "}</label>
                            <Form.Group controlId="tournamentList">
                                <MultiSelect
                                    name="builder_name"
                                    options={builderListDropDown}
                                    value={selectedBuilderNameByFilter}
                                    onChange={handleSelectBuilderNameChange}
                                    placeholder={"Select Builder Name"}
                                    hasSelectAll={true}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">SUBDIVISION NAME:{" "}</label>
                            <Form.Group controlId="tournamentList">
                                <LazySubdivisionMultiSelect
                                    builderIds={selectedBuilderIDByFilter}
                                    name="subdivision_name"
                                    value={selectedSubdivisionNameByFilter}
                                    onChange={handleSelectSubdivisionNameChange}
                                    placeholder={"Select Subdivision Name"}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">ADDRESS NUMBER:{" "}</label>
                            <input name="address2" value={filterQuery.address2} className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">ADDRESS NAME:{" "}</label>
                            <input name="address1" value={filterQuery.address1} className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">PARCEL NUMBER:{" "}</label>
                            <input value={filterQuery.parcel} name="parcel" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">SQUARE FOOTAGE:{" "}</label>
                            <input type="text" value={filterQuery.sqft} name="sqft" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">LOT NUMBER:{" "}</label>
                            <input value={filterQuery.lotnumber} name="lotnumber" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">PERMIT NUMBER:{" "}
                                 <div className="btn-tooltip" id="permitnumber">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#permitnumber"
                                      style={{ zIndex: 999 }}
                                      content={<>From Issuing Jurisdiction </>}
                                    />
                                 </div>
                            </label>
                            <input value={filterQuery.permitnumber} name="permitnumber" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3 ">
                            <label className="form-label">PLAN:{" "}</label>
                            <input value={filterQuery.plan} name="plan" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">PRODUCT TYPE:{" "}
                                <div className="btn-tooltip" id="product_type">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#product_type"
                                      style={{ zIndex: 999 }}
                                      content={<>DET: Single Family Detached <br />ATT: Attached ie. Condo/Townhome/Duplex/etc.
                                                 <br />HR: High Rise</>}
                                    />
                                </div>
                            </label>
                            <MultiSelect
                                name="product_type"
                                options={productTypeOptions}
                                value={productTypeStatusByFilter}
                                onChange={handleSelectProductTypeChange}
                                placeholder="Select Prodcut Type"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">AREA:{" "}
                                <div className="btn-tooltip" id="area">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#area"
                                      clickable={true} 
                                      style={{ zIndex: 999 }}
                                      content={
                                            <> 
                                            See our Sub-Market<br /> Area Map:{" "}                                 
                                                <a
                                                    href="https://www.homebuildersresearch.com/images/misc/sub_market_areas.png"
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >                      
                                                View Map
                                                </a>
                                            </>}
                                    />
                                </div>
                            </label>
                            <MultiSelect
                                name="area"
                                options={areaOption}
                                value={selectedAreaByFilter}
                                onChange={handleSelectAreaChange}
                                placeholder="Select Area"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">MASTERPLAN:{" "}</label>
                            <MultiSelect
                                name="masterplan_id"
                                options={masterPlanDropDownList}
                                value={selectedMasterPlanByFilter}
                                onChange={handleSelectMasterPlanChange}
                                placeholder="Select Area"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">ZIP CODE:{" "}</label>
                            <input 
                                type="text" 
                                name="zipcode" 
                                value={filterQuery.zipcode} 
                                className="form-control" 
                                onChange={HandleFilter} 
                                pattern="[0-9, ]*"
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9, ]/g, '');
                                }}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">LOT WIDTH:{" "}
                                <div className="btn-tooltip" id="lotwidth">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#lotwidth"
                                      style={{ zIndex: 999 }}
                                      content={<>Approximate average lot width</>}
                                    />
                                </div>
                            </label>
                            <input value={filterQuery.lotwidth} name="lotwidth" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">LOT SIZE:{" "}
                                <div className="btn-tooltip" id="lotsize">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#lotsize"
                                      style={{ zIndex: 999 }}
                                      content={<>Approximate average lot size (sqft) </>}
                                    />
                                </div>
                            </label>
                            <input value={filterQuery.lotsize} name="lotsize" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label htmlFor="exampleFormControlInput8" className="form-label">AGE RESTRICTED:{" "}</label>
                            <MultiSelect
                                name="age"
                                options={ageOptions}
                                value={selectedAgeByFilter}
                                onChange={handleSelectAgeChange}
                                placeholder={"Select Age"}
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label htmlFor="exampleFormControlInput8" className="form-label">All SINGLE STORY:{" "}</label>
                            <MultiSelect
                                name="single"
                                options={singleOptions}
                                value={selectedSingleByFilter}
                                onChange={handleSelectSingleChange}
                                placeholder={"Select Single"}
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">JURISDICTION:</label>
                            <MultiSelect
                                name="juridiction"
                                options={jurisdictionOption}
                                value={selectedJurisdicitionByFilter}
                                onChange={handleSelectJurisdictionChange}
                                placeholder="Select Juridiction"
                                hasSelectAll={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                        <label className="form-label">GAS PROVIDER:</label>
                        <MultiSelect
                            name="gasprovider"
                            options={gasProviderDropDown}
                            value={seletctedGasProviderByFilter}
                            onChange={handleGasProviderChange}
                            placeholder="Select Gas Provider"
                            hasSelectAll={true}
                        />
                    </div>
                    <br />
                    <div className="d-flex justify-content-between">
                        <Button
                            className="btn-sm"
                            onClick={HandleCancelFilter}
                            variant="secondary"
                        >
                            Reset
                        </Button>
                        <Button
                            className="btn-sm"
                            onClick={HandleFilterForm}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </div>
                </form>
            </div>

            {/* Popup */}
            <Modal show={showPopup} onHide={HandlePopupDetailClick}>
                <Modal.Header handlePopupClose>
                    <Modal.Title>Alert</Modal.Title>
                    <button
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handlePopupClose()}
                    ></button>
                </Modal.Header>
                <Modal.Body>
                    {message}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handlePopupClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default FilterPermits;
